import { Action } from '@ngrx/store';

export const UPDATE_FORM = "Formulario actualizado";


export class FormUpdate implements Action {
        readonly type = UPDATE_FORM;
        constructor(public payload: String, public title: String){
        }
}


export type All = FormUpdate;